module.exports = __webpack_public_path__ + "img/badge-list-thumb-106.415cdd0b.png";